<template>
  <div class="home page">
    <div class="wrapper">
      <div class="home-inner container">
        <h1 v-if="cinema" class="title movie-title" style="text-align: center;">{{ cinema.data.cinemaName }}</h1>
        <div style="display: flex;justify-content: space-between; align-items: center;">
          <h2 class="title movie-title">{{ $t('movie.schedule') }}</h2>
          <button class="today" @click="backToday">本日</button>
        </div>
        <div class="movie-container">
          <MovieSwiper :movies="movies" :active-index="swiperIndex" @slideChange="updateSelectedMovie"></MovieSwiper><!-- mobile version only -->
          <div class="movie-schedule">
            <div class="movie-schedule-head">
              <div v-if="selectedMovie" class="movie-schedule-info">
                <h2 class="text-center">{{ selectedMovie.text }}</h2>
                <p class="text-center"><label class="info">
                  <template v-for="(tag, idx) in selectedMovie.tag">
                    <template v-if="idx !== 0">/</template>
                    {{ tag }}
                  </template>
                </label></p>
                <p class="text-center"></p>
              </div>
              <CalendarHead ref="calendarHead" :window-width="windowWidth" :parentDateClickHandler="onDateChange"></CalendarHead>
            </div>
            <div class="loader" v-if="isLoading"></div>
            <div v-if="movies.length && !isLoading" class="movie-schedule-body" >
              <template  v-if="windowWidth > mobileWidth">
                <div v-for="(movie, idx) in movies" :key="idx" class="movie-schedule-item">
                  <span style="font-weight: 700;font-size: 20px;margin-right: 10px;">{{ movie.text }}</span><label v-if="movie.category !== 'なし'" class="info" style="font-size: 20px">{{ movie.category }}</label>
                  <div class="schedule-container">
                      <div class="image">
                        <img :src="getProxyImageUrl(movie.image)" />
                      </div>
                  <div class="schedule">
                  <table class="schedule-table">
                  <tbody v-for="(schedule, j) in movie.schedules" :key="`movie-${idx}-schedule-${j}`">

                    <tr v-for="item in schedule.rowspan" :key="item">
                      <!-- <td class="image" :class="{ 'full-height': movie.schedules.length === 2 }" v-if="j === 0" :rowspan="movie.needSpan">
                        <img :src="movie.image"/>
                      </td> -->

                      <td class="place" :rowspan="`${schedule.rowspan}`" v-if="item === 1">
                        <div>
                          <span class="name">{{ schedule.name }}</span>
                          <!-- <span class="type text-style-2 text-sub-color">{{ schedule.type }}</span> -->
                          <a v-if="cinema" @click="index = (seatingPhotos.findIndex(item => item.url === schedule.photo))" class="seating-img-btn" :style="`color: ${cinema.data.mainColor}`">座席表 ></a>
                        </div>
                      </td>
                      <template v-for="(slot, k) in schedule.slots">
                      <td style="padding-bottom: 10px;" class="slot" v-if="k >= (item - 1) * 5 && k < item * 5" :key="k" @click="routerToBuy(`${slot.href}`, slot, slot.buttonText)">
                        <h2>{{ slot.start }}</h2>
                        <p>{{ slot.end }}</p>
                        <!-- version tag -->
                        <div class="info-list" style="margin-bottom: 10px;">
                          <label v-if="slot.type" class="info">{{slot.type}}</label>
                          <label v-if="slot.version2 && slot.version2 !== 'なし'" :class="['info', slot.version2 === '字幕' ? 'SUB' : 'DUB']">{{slot.version2}}</label>
                          <label class="info" v-for="(str, idx) in slot.version3" :key="idx">{{str}}</label>
                        </div>
                        <a v-if="slot.isSalesOpen" class="presale-icon-container">
                          <img v-if="getDiaplayPreSaleIcon(slot.webPreSaleTime, slot.startSalesTime, slot.webPreSaleRule)" class="presale-icon" src="../../assets/images/presaleIcon_512w.png" alt="presaleIcon" />
                          <button class="purchase-button" :style="`background-color: ${slot.buttonColor}`">{{ getBtnText(slot) }}</button>
                        </a>
                        <div class="no-purchase" v-else></div>
                      </td>
                      </template>
                      <template v-if="item === Math.ceil(schedule.slots.length / 5) && (schedule.slots.length % 5) !== 0">
                      <td v-for="idx in (5 - schedule.slots.length % 5)" class="slot" :key="`movie-${idx}-schedule-${idx}-empty-slot-${j}`"></td>
                    </template>
                      <!-- <td v-for="k in (schedule.slots.length)" class="slot" :key="`movie-${idx}-schedule-${j}-empty-slot-${k}`"></td> -->
                    </tr>
                  </tbody>
                  </table>
                  </div>
                  </div>
                  <vue-gallery-slideshow :images="seatingPhotos" :index="index" @close="index = null"></vue-gallery-slideshow>
                </div>
              </template>
              <template v-else>
                <div v-for="(schedule, idx) in (selectedMovie ? selectedMovie.mobileSchedules : [])" :key="idx">
                  <div class="movie-schedule-info flex-row">
                    <div class="time">
                      <h2>{{ schedule.start }}</h2>
                      <p>{{ schedule.end }}</p>
                    </div>
                    <div class="room">
                      <p class="name text-sub-color">{{ schedule.name }}</p>
                      <!-- <p class="type text-sub-color">{{ slot.type }}</p> -->
                    </div>
                    <!-- version tag -->
                    <div class="info-list" style="margin-bottom: 10px;">
                      <label v-if="schedule.type" class="info">{{schedule.type}}</label>
                      <label v-if="schedule.version2 && schedule.version2 !== 'なし'" :class="['info', schedule.version2 === '字幕' ? 'SUB' : 'DUB']">{{schedule.version2}}</label>
                      <label class="info" v-for="(str, idx) in schedule.version3" :key="idx">{{str}}</label>
                    </div>
                    <div class="purchase">
                      <a v-if="schedule.isSalesOpen" class="presale-icon-container" :href="`${ schedule.purchasable ? schedule.href : 'javascript:;' }`" :target="((getDiaplayPreSaleIcon(schedule.webPreSaleTime, schedule.startSalesTime, schedule.webPreSaleRule) || schedule.purchasable) ? '_blank' : '')">
                        <img v-if="getDiaplayPreSaleIcon(schedule.webPreSaleTime, schedule.startSalesTime, schedule.webPreSaleRule)" class="presale-icon" src="../../assets/images/presaleIcon_512w.png" alt="presaleIcon" />
                        <button class="purchase-button" :style="`background-color: ${schedule.buttonColor}`">
                          <!-- {{ slot.buttonText }} -->
                          {{ getBtnText(schedule) }}
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </template>
            </div><!-- mobile version hide -->
            <Empty v-else-if="isApiError" type="film" text="error" :disabled="isDisabled" @refresh="refresh_fn" />
            <Empty v-else type="film"></Empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
// import BannerNews from '../../components/bannerNews/BannerNews'
// import News from '../../components/news/News'
// import Address from '../../components/address/Address'
import CalendarHead from '../../components/calendarHead/CalendarHead'
import MovieSwiper from '../../components/movieSwiper/MovieSwiper'
import Empty from '../../components/empty/Empty'
import { ApiService } from '@/services/api.service'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import _ from 'lodash'
import { getBtnText } from '../../services/util'
export default {
  name: 'IndexPage',

  components: {
    // BannerNews,
    // News,
    // Address,
    CalendarHead,
    MovieSwiper,
    Empty,
    VueGallerySlideshow
  },

  data () {
    return {
      isDisabled: false,
      isLoading: false,
      isApiError: false,
      fetchRequestId: 0,
      windowWidth: null,
      tagFilter: [
        { value: 'all', label: this.$i18n.messages[this.$i18n.fallbackLocale].news.allLabel },
        { value: 'importantNotice', label: '重要なお知らせ' },
        { value: 'notice', label: 'お知らせ' },
        { value: 'activity', label: 'イベント' },
        { value: 'send', label: '配信' },
        { value: 'campaign', label: 'キャンペーン' }
      ],
      newsList: [],
      movies: [],
      swiperIndex: 0,
      selectedMovieId: null,
      address: {
        name: 'Tollywood',
        location: '東京都世田谷区代沢5-32-5-2F',
        tel: '03-3414-0433',
        email: '1234567@gmail.com'
      },
      index: null,
      getBtnText
    }
  },
  computed: {
    place () {
      return encodeURI(this.address.location + ' ' + this.address.name)
    },
    mobileWidth () {
      return this.$store.state.dom.widthSmall
    },
    cinema () {
      return this.$store.state.cinema.cinema
    },
    selectedMovie () {
      // swiperIndex 可能因為切換日期後片單變短而超出範圍，這裡統一取安全值
      return this.movies[this.swiperIndex] || this.movies[0] || null
    },
    seatingPhotos () {
      const result = []
      this.movies.forEach(movie => movie.schedules.forEach(schedule => {
        result.push({
          url: schedule.photo,
          alt: schedule.name
        })
      }))

      return result
    },
    housePhotos () {
      const result = this.cinema.houseList.map(item => item.housePhoto) || []
      return result
    }
  },
  watch: {
    movies (list) {
      // 換日期重新取得片單後，優先沿用原本選取的電影；新片單裡找不到才回到第一部
      const idx = this.selectedMovieId == null
        ? -1
        : list.findIndex(movie => movie.id === this.selectedMovieId)
      this.swiperIndex = idx >= 0 ? idx : 0
      if (list.length) {
        // 片單為空時保留原本的 id，之後切回有該部片的日期還能還原選取
        this.selectedMovieId = list[this.swiperIndex].id
      }
    }
  },
  methods: {
    // fetchNews () {
    //   ApiService.listNewsByOrganisationAndDate('all', 'all').then(res => {
    //     this.newsList = res.content.map(news => {
    //       return {
    //         ...news,
    //         image: this.getNewsImage(this.base64Decode(news.content)),
    //         content: this.getNewsText(this.base64Decode(news.content)),
    //         tag: [this.categoryDisplay(news.category)]
    //       }
    //     })
    //   }).catch(error => {
    //     console.error(error.response)
    //     this.dataError = true
    //   })
    // },
    routerToBuy (url, slot, text) {
      const { purchasable } = slot
      if (purchasable) {
        window.open(url)
      }
      // if (isRouter) {
      //   window.location.href = url
      // }
    },
    categoryDisplay (category) {
      const item = this.tagFilter.find(item => item.value === category)
      return item ? item.label : ''
    },
    htmlToElements (html) {
      return new DOMParser().parseFromString(html, 'text/html')
    },
    getNewsImage (content) {
      const images = this.htmlToElements(content).getElementsByTagName('img')
      if (images.length) {
        return images[0].getAttribute('src')
      }
      return null
    },
    getNewsText (content) {
      const text = this.htmlToElements(content).getElementsByTagName('p')
      if (text.length) {
        return text[0].innerText
      }
      return content
    },
    base64Decode (encodedString = '') {
      try {
        return decodeURIComponent(escape(window.atob(encodedString)))
      } catch (e) {
        console.error(e)
      }
      return encodedString
    },
    updateSelectedMovie (index) {
      if (index >= 0 && index < this.movies.length) {
        this.swiperIndex = index
        this.selectedMovieId = this.movies[index].id
      }
    },
    updateWindowWidth () {
      this.windowWidth = window.innerWidth
    },
    onDateChange (date) {
      // turn on loading
      this.isLoading = true
      this.fetchMovieListByDate(date)
    },
    parseShowList (data, date) {
      const movieList = data.map(movie => {
        const { movieDetail, houseList } = movie
        const { movieId, movieName, stillsUrl, genres, durationMin } = movieDetail
        let total = 0
        let scheduleArr = []
        const movieItem = {
          id: movieId,
          text: movieName,
          image: stillsUrl.length ? stillsUrl[0] : null,
          tag: genres,
          time: durationMin,
          category: movieDetail.category,
          schedules: houseList.map(house => {
            const { houseName, housePhoto, versions, showList } = house
            total += Math.ceil(showList.length / 5)
            return {
              name: houseName,
              type: versions,
              photo: housePhoto,
              slots: showList.map(show => {
                const { showId, startTime, endTime, ticketingUrl, version, congestionStatus, colorCode, purchasable } = show
                const StartHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(startTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(startTime).utc().zone(-9).hour() + 24 : moment(startTime).utc().zone(-9).hour())
                const EndHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(endTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(endTime).utc().zone(-9).hour() + 24 : moment(endTime).utc().zone(-9).hour())
                return {
                  id: showId,
                  isSalesOpen: purchasable,
                  // start: moment(startTime).format('HH:mm'),
                  start: `${StartHour}:${moment(startTime).format('mm')}`,
                  // end: moment(endTime).format('HH:mm'),
                  end: `${EndHour}:${moment(endTime).format('mm')}`,
                  // status: this.getShowStatus(show),
                  href: ticketingUrl,
                  type: version,
                  buttonColor: colorCode,
                  buttonText: congestionStatus
                }
              }),
              rowspan: Math.ceil(showList.length / 5)
            }
          }),
          mobileSchedules: [],
          needSpan: total
        }
        houseList.map(house => {
          const { showList } = house
          total += Math.ceil(showList.length / 5)

          scheduleArr = [...scheduleArr, ...this.versionCut(house, date)]
        })

        movieItem.needSpan = total
        console.log(scheduleArr)
        const _schedule = []
        scheduleArr.forEach(item => {
          item.slots.forEach(schedule => {
            // _schedule.push(schedule)
            _schedule.push({
              ...schedule,
              name: item.name
            })
          })
        })
        movieItem.mobileSchedules = _.sortBy(_schedule, function (o) {
          return moment(`${date} ${o.start}`).valueOf()
        })
        movieItem.schedules = scheduleArr
        return movieItem
      })
      return movieList
    },
    versionCut (data, date) {
      const versionList = []
      const scheduleArr = []
      const textObj = {
        '◯ 余裕あり': '◯ 購入',
        '△ 残りわずか': '△ 購入',
        '✕ 満席': '✕ 満席'
      }
      data.showList.map(item => {
        const { startTime, endTime, purchasable, startSalesTime, webPreSaleTime, webPreSaleRule, stopSalesTime } = item
        const StartHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(startTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(startTime).utc().zone(-9).hour() + 24 : moment(startTime).utc().zone(-9).hour())
        const EndHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(endTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(endTime).utc().zone(-9).hour() + 24 : moment(endTime).utc().zone(-9).hour())
        const isPreSaleMode = (webPreSaleTime > 0) && (moment().valueOf() > webPreSaleTime) && (moment().valueOf() < moment(stopSalesTime).valueOf())
        const trItem = {
          id: item.showId,
          purchasable,
          isPreSaleMode,
          // isSalesOpen: moment().isBetween(moment(item.startSalesTime), moment(item.stopSalesTime), 'second'),
          isSalesOpen: purchasable || isPreSaleMode,
          // start: moment(startTime).format('HH:mm'),
          start: `${StartHour}:${moment(startTime).format('mm')}`,
          // end: moment(endTime).format('HH:mm'),
          end: `${EndHour}:${moment(endTime).format('mm')}`,
          // status: this.getShowStatus(item),
          startSalesTime,
          webPreSaleTime,
          webPreSaleRule,
          href: item.ticketingUrl,
          type: item.version,
          // buttonColor: isPreSaleMode ? '#6DF728' : item.colorCode,
          buttonColor: (purchasable || textObj[item.congestionStatus]) ? item.colorCode : '#6DF728',
          // buttonText: isPreSaleMode ? '◯ 余裕あり' : item.congestionStatus,
          buttonText: (purchasable || textObj[item.congestionStatus]) ? item.congestionStatus : '◯ 余裕あり',
          version2: item.version2,
          version3: item.version3
        }

        if (versionList.indexOf(item.version) >= 0) {
          scheduleArr[versionList.indexOf(item.version)].slots.push(trItem)
        } else {
          versionList.push(item.version)
          scheduleArr.push({
            name: data.houseName,
            type: item.version,
            photo: data.housePhoto,
            slots: [trItem],
            rowspan: Math.ceil(data.showList.length / 5)
          })
        }
      })

      return scheduleArr
    },
    fetchMovieListByDate (date) {
      const requestId = ++this.fetchRequestId
      ApiService.listByDomainAndDate(this.$route.query.webKey, date).then((res) => {
        if (requestId !== this.fetchRequestId) return
        this.isLoading = false
        const { status } = res
        this.isApiError = status !== 200
        // 先在區域變數整理好片單，最後一次性指派，避免 watch 被觸發兩次而選錯片
        let list = status === 200 ? this.parseShowList(res.data, date) : []
        if (status === 200) {
          list.forEach((item) => {
            let number = 0
            item.schedules.forEach((schedule) => {
              item.scheduleNumber = number += schedule.slots.length
            })
          })
          list = _.sortBy(list, [function (o) {
            return -o.scheduleNumber
          }])
        }
        this.movies = list
      }).catch((error) => {
        if (requestId !== this.fetchRequestId) return
        this.movies = []
        this.isApiError = true
        this.isLoading = false
        console.error(error.response)
        this.dataError = true
      })
    },
    refresh_fn () {
      if (!this.isDisabled) {
        this.fetchMovieListByDate(this.$refs.calendarHead.selectDate)
        this.isDisabled = true
        setTimeout(() => {
          this.isDisabled = false
        }, 5000)
      }
    },
    backToday () {
      this.$refs.calendarHead.weekIndex = 0
      this.$refs.calendarHead.date = moment().format('YYYY-MM-DD')
      this.$refs.calendarHead.calSelectDate()

      this.$refs.calendarHead.$refs.mySwiper.$swiper.slideTo(0)
    },
    getDiaplayPreSaleIcon (webPreSaleTime, webStartSalesTime, webPreSaleRule) {
      const _startSalesTime = moment(webStartSalesTime).valueOf()
      const _webPreSaleTime = moment(webPreSaleTime).valueOf()
      const curTime = moment().valueOf()
      if (webPreSaleRule && webPreSaleRule.length > 0 &&
      _webPreSaleTime <= curTime && curTime < _startSalesTime) {
        return true
      }
      return false
    },
    getProxyImageUrl (url) {
      if (!url) {
        return ''
      }

      if (url.startsWith('https://')) {
        return url
      }

      if (url.startsWith('http://')) {
        const proxyUrl = `https://images.weserv.nl/?url=${encodeURIComponent(url.replace('http://', ''))}`
        return proxyUrl
      }

      return url
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', this.updateWindowWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateWindowWidth)
  },
  created () {
    // this.fetchNews()
    // this.fetchMovieListByDate(moment().format('YYYY-MM-DD'))
  }
}
</script>

<style lang="scss" scoped>
  .home {
    .home-inner {
      h2.title {
        margin: 70px 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: 0.72px;
          color: var(--Secondary-font-color);
          text-decoration: none;

          span {
            margin-left: 7px;

            .chevron {
              border-color: var(--Secondary-font-color);
            }
          }

          @include media_mobile {
            display: none;
          }
        }

        &.news-title {
          margin-top: 40px;

          @include media_mobile {
            justify-content: center;
            margin: 0;
            padding: 5px 0 10px;
          }
        }

        @include media_mobile {
          margin: 0;
          padding: 5px 0 10px;
          font-weight: 600;
          line-height: normal;
          letter-spacing: 0.81px;
        }
      }
      .today {
        height: 30px;
        padding: 5px;
        margin-top: 70px;
        @include media_mobile {
          margin-top: 0;
        }
      }

      .movie-container {
        .movie-schedule {
          .movie-schedule-head {
            border: 0 solid;
            border-radius: 3px;
            box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
            background-color: var(--Card-background-color);

            .movie-schedule-info {
              display: none;

              h2 {
                font-size: 18px;
                font-weight: 500;
                line-height: normal;
                letter-spacing: 0.81px;
                margin-top: 10px;
              }

              .info {
                background-color: rgba(22, 23, 27, 0.6);
                margin-top: 5px;
              }

              a.more-anchor {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 10px;
                font-weight: 600;
                line-height: normal;
                letter-spacing: 0.45px;
                color: var(--Secondary-font-color);
                text-decoration: none;

                span {
                  margin-left: 7px;

                  .chevron {
                    border-color: var(--Secondary-font-color);
                  }
                }
              }

              @include media_mobile {
                display: block;
              }
            }

            .calendar-head {
              @include media_mobile {
                border: solid 1px $color-grey-7;
                margin-top: 10px;
              }
            }

            @include media_mobile {
              margin: 0 -10px;
              width: calc(100% + 20px);
              box-shadow: none;
             //border: solid 1px $color-grey-7;
            }
          }

          .loader, .loader:after {
            border-radius: 50%;
            width: 10em;
            height: 10em;
          }
          .loader {
            margin: 60px auto;
            font-size: 10px;
            position: relative;
            text-indent: -9999em;
            border-top: 1.1em solid rgba(255, 255, 255, 0.2);
            border-right: 1.1em solid rgba(255, 255, 255, 0.2);
            border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
            border-left: 1.1em solid #9e9e9e;
            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);
            -webkit-animation: load8 1.1s infinite linear;
            animation: load8 1.1s infinite linear;
          }
          @-webkit-keyframes load8 {
            0% {
              -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
          @keyframes load8 {
            0% {
              -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }

          .schedule-container{
            display: flex;
          }

          .movie-schedule-body {
            .movie-schedule-item {
              display: block;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              margin-top: 10px;
              width: 100%;
              padding: 15px;
              border: 0 solid;
              border-radius: 3px;
              box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
              background-color: var(--Card-background-color);

              > h2 {
                margin-bottom: 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                a {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  font-size: 16px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: 0.72px;
                  color: var(--Secondary-font-color);
                  text-decoration: none;

                  span {
                    margin-left: 7px;

                    .chevron {
                      border-color: var(--Secondary-font-color);
                    }
                  }
                }
              }

              .schedule {
                width: 100%;
                height: unset;
              }

              .schedule-table {
                width: 100%;
                height: 100%;
                border-collapse: collapse;
                border: 1px $color-grey-2 solid;

                td {
                  border: 1px $color-grey-2 solid;
                  width: calc(100% / 914 * 748 / 6);
                  height: 90px;
                  vertical-align: middle;

                  &.place {
                    background-color: rgba(67, 67, 67, 0.1);
                    vertical-align: middle;

                    div {
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      height: 100%;

                      span.name {
                        font-size: 16px;
                        font-weight: 500;
                        letter-spacing: 0.72px;
                        margin-bottom: 5px;
                        text-align: center;
                      }

                      a {
                        margin-top: 12px;
                        font-size: 10px;
                        font-weight: 500;
                        color: $color-pink-2;
                      }

                      .seating-img-btn {
                        &:hover {
                          cursor: pointer;
                        }
                      }
                    }
                  }

                  &.slot {
                    position: relative;
                    padding: 5px 15px 0;
                    text-align: center;
                    vertical-align: middle;

                    p {
                      font-size: 16px;
                      font-weight: 500;
                      line-height: normal;
                      letter-spacing: 0.72px;
                      color: var(--Secondary-font-color);
                    }
                    .presale-icon-container {
                      position: relative;
                      .purchase-button {
                        min-width: 80px;
                        border: 0 solid;
                        border-radius: 3px;
                        // color: var(--Button-font-color);
                        font-size: 14px;
                        font-weight: 500;
                        line-height: normal;
                        letter-spacing: 0.63px;
                        padding: 2px 15px;
                      }
                      .presale-icon {
                        width: 40px;
                        // 放在右上角
                        position: absolute;
                        top: -25px;
                        right: -25px;
                      }
                    }

                    .no-purchase {
                      height: 24px;
                    }

                    &.warning {
                      .purchase-button {
                        background-color: $color-orange-2;
                      }
                    }

                    &.occupy {
                      .purchase-button {
                        background-color: $color-red-1;
                      }
                    }
                  }
                }
              }
            }

            .image {
                    width: calc(100% / 914 * 166);
                    height: inherit;
                    padding-right: 10px;
                    margin: auto;

                    img {
                      width: 100%;
                    }

                    &.full-height {
                      height: 180px;

                      img {
                        height: calc(100% - 25px);
                        width: auto;
                      }
                    }
                  }

            .movie-schedule-info {
              position: relative;
              align-items: center;
              padding: 15px 0;
              border-bottom: 1px solid $color-grey-7;
              .time {
                width: 80px;

                p {
                  color: var(--Secondary-font-color);
                }
              }

              .room {
                flex: 1;
              }

              .purchase {
                .presale-icon {
                  // 放在右上角
                  width: 40px;
                  position: absolute;
                  top: 5px;
                  right: 0px;
                }
              }

              .purchase-button {
                min-width: 80px;
                background-color: $color-green-1;
                border: 0 solid;
                border-radius: 3px;
                // color: var(--Button-font-color);
                font-size: 14px;
                font-weight: 500;
                line-height: normal;
                letter-spacing: 0.63px;
                padding: 2px 15px;
                margin-right: 20px;
              }

              &.warning {
                .purchase-button {
                  background-color: $color-orange-2;
                }
              }

              &.occupy {
                .purchase-button {
                  background-color: $color-red-1;
                }
              }

              &.expired {
                h2 {
                  color: var(--Secondary-font-color);
                }
              }
            }
          }
        }

        .movie-swiper {
          display: none;
          margin: 0 -10px;
          width: calc(100% + 20px);
          background-color: var(--Background-color);

          @include media_mobile {
            display: block;
          }
        }

        @include media_mobile {
          background-color: var(--Card-background-color);
          box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
          padding: 0 10px 10px;
        }
      }
    }

    @include media_mobile {
      background-color: var(--Background-color);
      margin-top: 44px;
    }
  }
</style>
